// extracted by mini-css-extract-plugin
module.exports = {"card":"SiteDetails_card__3LHih","title":"SiteDetails_title__t9deu","table":"SiteDetails_table__6QAvW"};